// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gastrodon: PokeData = {
  "id": 423,
  "name": "gastrodon",
  "height": 9,
  "weight": 299,
  "base_experience": 166,
  "types": [
    PokeType.WATER,
    PokeType.GROUND
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "water-gun",
    "hydro-pump",
    "recover",
    "harden",
    "mud-slap",
    "hidden-power",
    "rain-dance",
    "ancient-power",
    "memento",
    "mud-sport",
    "muddy-water",
    "water-pulse",
    "earth-power",
    "mud-bomb"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "hydro-pump",
    "mud-slap",
    "rain-dance",
    "ancient-power",
    "earth-power",
    "mud-bomb",
    "brine",
    "bonemerang",
    "aqua-jet",
    "earthquake",
    "mud-shot"
  ],
  "evolution_chain": {
    "id": 218,
    "item": null,
    "species": [
      {
        "name": "shellos",
        "order": 450,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gastrodon",
        "order": 451,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 422,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 166,
    "speed": 70,
    "ability_power": 164
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
